import { GET_FOUNDATIONS } from './../constants';
import { handleActions } from "redux-actions"

export const foundations  = handleActions(
  {
    [ GET_FOUNDATIONS ]: (state, action) => action.payload.data
  }, []
)